<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch00_fm08_ill"><a id="page_xvi"></a>ILLUSTRATIONS</h2>
<p class="noindent2">F<span class="small">IGURES</span></p>
<p class="indentm"><a class="nounder" href="#/xhtml/ch01#ch01fig1">1. Paleo-American hunting scene</a></p>
<p class="indentm"><a class="nounder" href="#/xhtml/ch01#ch01fig2">2. Projectile points from Paleo-American, Archaic, and Neo-American stages</a></p>
<p class="indentm"><a class="nounder" href="#/xhtml/ch02#ch03fig1">3. Coahuiltecan carrying a burden</a></p>
<p class="indentm"><span class="nounder" href="#/xhtml/ch03#ch03fig2" title="Link target outside of Sample">4. Karankawa dancers</span></p>
<p class="indentm"><span class="nounder" href="#/xhtml/ch05#ch05fig1" title="Link target outside of Sample">5. Lipan warrior and his wife</span></p>
<p class="indentm"><span class="nounder" href="#/xhtml/ch06#ch06fig1" title="Link target outside of Sample">6. Tonkawa burial scene</span></p>
<p class="indentm"><span class="nounder" href="#/xhtml/ch07#ch07fig1" title="Link target outside of Sample">7. Comanche warrior</span></p>
<p class="indentm"><span class="nounder" href="#/xhtml/ch08#ch08fig1" title="Link target outside of Sample">8. Kiowa sun dancer</span></p>
<p class="indentm"><span class="nounder" href="#/xhtml/ch09#ch09fig1" title="Link target outside of Sample">9. “Standing on top of their houses they showed great merriment on seeing us.” (Hernán Gallegos)</span></p>
<p class="indentm1"><span class="nounder" href="#/xhtml/ch10#ch10fig1" title="Link target outside of Sample">10. Tattooed Wichita women plaiting pumpkin fibers</span></p>
<p class="indentm1"><span class="nounder" href="#/xhtml/ch11#ch11fig1" title="Link target outside of Sample">11. Caddo village scene</span></p>
<p class="indentm1"><span class="nounder" href="#/xhtml/ch12#ch12fig1" title="Link target outside of Sample">12. Atakapan in a dugout canoe</span></p>
<p class="noindent2">M<span class="small">APS</span></p>
<p class="indentm"><a class="nounder" href="#/xhtml/ch02#ch02map1">1. Texas Tribes of the Western Gulf Culture Area</a></p>
<p class="indentm"><span class="nounder" href="#/xhtml/ch04#ch04map2" title="Link target outside of Sample">2. The Southern Plains and Southwest Texas in Prehorse Times</span></p>
<p class="indentm"><span class="nounder" href="#/xhtml/ch07#ch07map1" title="Link target outside of Sample">3. The Texas Plains, 19th Century</span></p>
<p class="indentm"><span class="nounder" href="#/xhtml/ch11#ch11map1" title="Link target outside of Sample">4. Texas Tribes of the Southeast Culture Area</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm08_ill.vue?6e5b6ce4